import { render, staticRenderFns } from "./BlockedTag.vue?vue&type=template&id=0be6da70&scoped=true"
import script from "./BlockedTag.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockedTag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BlockedTag.vue?vue&type=style&index=0&id=0be6da70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be6da70",
  null
  
)

export default component.exports